import styled from 'styled-components';

export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  overflow: visible !important;
`;

export const MainContent = styled.main`
  flex: 1;
  width: 100%;
  overflow: visible !important;
`;